/* THIS FILE IS GENERATED BY AssistantContextTypeScriptGenerator. */
export type PageAssistantContext = { routeId: string; params: Record<string, string> }

export type AssistantContextItem =
  | { kind: "page"; value: PageAssistantContext }

export const assistantContext = {
  page: (value: PageAssistantContext) => ({ kind: "page", value }) as const,
} as const
